<textarea
  pInputTextarea
  [formControl]="control()"
  [placeholder]="placeholder"
  [class]="cssClass"
  [variant]="variant"
  [rows]="rows"
  [cols]="cols"
  [ospTrimInput]="$trimEnabled()"
></textarea>
